<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12" lg="12" class="pb-0 pt-0">
				<v-card flat>
					<v-card-text class="pb-0 pt-2">
						<v-row class="pb-1">
							<v-col class="d-flex justify-start pa-0 pl-2">
								<v-btn color="primary" @click="addClick">
									<v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.add') }}
								</v-btn>
							</v-col>
							<v-col class="d-flex justify-center pb-0 pt-0">
								<v-card-title class="text-center pa-2 pb-2 pt-0">
									{{ $t('modules.brevetsRenewal') }}</v-card-title
								>
							</v-col>
							<v-col></v-col>
						</v-row>
						<v-row>
							<v-col class="pb-0 pt-0">
								<TheTable
									:additional-filters="brevetsTable.additionalFilters"
									:default-sort="brevetsTable.defaultSort"
									:excel="true"
									:fields="brevetsTable.headers"
									:header-selection-key="'brevets-headers'"
									:height="brevetsTable.height"
									:total-records="brevetsTable.total"
									:filter-save-key="'brevets-filters'"
									@excel="excelExport"
									@headers="selectHeaders"
									@reload="reloadData"
								>
									<tr
										v-for="(item, key) in brevetsTable.items"
										:key="key"
										:class="{ 'cursor-pointer': true }"
										@contextmenu.prevent="editClick(props.item.id, true)"
									>
										<td
											v-if="brevetsTable.selectedHeaders.includes('date')"
											@click="editClick(item.id, false)"
										>
											{{
												item.date != null ? item.date.split('-').reverse().join('.') + '.' : ''
											}}
										</td>
										<td
											v-if="brevetsTable.selectedHeaders.includes('last_name')"
											@click="editClick(item.id, false)"
										>
											<b>{{ item.candidate.last_name }}</b>
										</td>
										<td
											v-if="brevetsTable.selectedHeaders.includes('first_name')"
											@click="editClick(item.id, false)"
										>
											<b>{{ item.candidate.first_name }}</b>
										</td>
										<td
											v-if="brevetsTable.selectedHeaders.includes('oib')"
											@click="editClick(item.id, false)"
										>
											{{ item.candidate.oib }}
										</td>
										<td
											v-if="brevetsTable.selectedHeaders.includes('course_id')"
											@click="editClick(item.id, false)"
										>
											<b>{{ item.course_id != null ? item.course.name : '' }}</b>
										</td>
										<td
											style="text-align: right"
											v-if="brevetsTable.selectedHeaders.includes('price')"
											@click="editClick(item.id, false)"
										>
											{{
												item.course_id != null
													? Number.isInteger(item.price)
														? item.price.toLocaleString('hr') + ',00'
														: /^\d+\.\d{1}$/.test(item.price.toString())
														? item.price.toLocaleString('hr') + '0'
														: item.price.toLocaleString('hr')
													: ''
											}}
										</td>
										<td>
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														icon
														small
														v-bind="attrs"
														@click="editClick(item.id, true)"
														v-on="on"
													>
														<v-icon small>fa-external-link-alt</v-icon>
													</v-btn>
												</template>
												<span>{{ $t('tooltips.openInNewTab') }}</span>
											</v-tooltip>
										</td>
									</tr>
								</TheTable>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import TheTable from '../../trinkets/TheTable';

export default {
	name: 'Brevets',
	components: { TheTable },
	data: function () {
		return {
			brevetsTable: {
				selectedHeaders: [],
				headers: [
					{ text: this.$t('fields.date'), value: 'date', type: '', allowFilter: true },
					{ text: this.$t('fields.lastName'), value: 'last_name', type: 'string', allowFilter: true },
					{ text: this.$t('fields.firstName'), value: 'first_name', type: 'string', allowFilter: true },
					{ text: this.$t('fields.oib'), value: 'oib', type: 'string', allowFilter: true },
					{
						text: this.$t('fields.course'),
						value: 'course_id',
						type: 'dropdown|courses',
						allowFilter: true,
					},
					{ text: this.$t('fields.price'), value: 'price', type: '', allowFilter: true, alignRight: true },
					{ text: '', value: 'actions', type: '', sortable: false, width: '100px', allowFilter: false },
				],
				additionalFilters: [
					{ text: this.$t('fields.date'), value: 'date', type: 'date_range' },
					{ text: this.$t('fields.price'), value: 'price', type: 'price_range' },
				],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'date',
					descending: true,
				},
			},
		};
	},
	methods: {
		addClick() {
			this.$router.push('/brevets/0');
		},
		editClick(id, newTab = false) {
			if (!newTab) {
				this.$router.push('/brevets/' + id);
			} else {
				let routeData = this.$router.resolve('/brevets/' + id);
				window.open(routeData.href, '_blank');
			}
		},
		selectHeaders(headers) {
			this.brevetsTable.selectedHeaders = headers;
		},
		reloadData(request) {
			this.brevetsTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'brevets',
				request,
				(data, success) => {
					if (success) {
						vm.brevetsTable.items = data.items;
						vm.brevetsTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		excelExport() {
			let excelRequest = JSON.parse(JSON.stringify(this.brevetsTable.lastRequest));
			excelRequest.pagination.itemsPerPage = 999999999;
			excelRequest.pagination.page = 1;

			let vm = this;
			this.$APICall(
				'get',
				'brevets',
				excelRequest,
				(data, success) => {
					if (success) {
						vm.$APICall('post', 'excel/brevets', data.items, (data, success) => {
							window.open(data.link);
						});
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		resolveWindowResize() {
			this.brevetsTable.height = window.innerHeight - 243 + 'px';
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}

		this.$myStore.commit('setBreadcrumbs', [
			{ text: this.$t('modules.brevetsRenewal'), href: '/#/brevets', disabled: true },
		]);

		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped></style>
